export const GET_DEVICE_LOG = "GET_DEVICE_LOG";
export const GET_DEVICE_LOG_DEBUG = "GET_DEVICE_LOG_DEBUG";

export const CLEAR_DEVICE_LOG = "CLEAR_DEVICE_LOG";
export const CLEAR_DEVICE_LOG_DEBUG = "CLEAR_DEVICE_LOG_DEBUG";

export const SET_DEVICE_LOG_LOADING_STATUS = 'SET_DEVICE_LOG_LOADING_STATUS';

export const SET_DEVICE_LOG_SELECTED_DVID = "SET_DEVICE_LOG_SELECTED_DVID";
export const CLEAR_DEVICE_LOG_SELECTED_DVID = "CLEAR_DEVICE_LOG_SELECTED_DVID";